import { Component, Input } from '@angular/core';
import { Action } from '@check-list/app/classes/models/action.model';
import { MenuItemsData } from '@check-list/core/consts/menu-items-data.const';
import { UploadEntity } from '@check-list/core/models/upload-entity.model';
import { StorageService } from '@check-list/shared/services/storage/storage.service';

@Component({
  selector: 'authority-labs-files-storage',
  templateUrl: './files-storage.component.html',
  styleUrls: ['./files-storage.component.scss']
})
export class FilesStorageComponent {
  @Input() folderId: string;
  @Input() subFolders: Record<string, string>;
  @Input() entity: UploadEntity;

  translationPath = 'fileStorage.';

  menuActions: Action[] = [
    MenuItemsData.OPEN_STORAGE.setFunction(this.storageNavigate.bind(this)),
    MenuItemsData.UPLOAD.setFunction(this.openUploadWindow.bind(this))
  ];

  constructor(private repoService: StorageService) {}

  storageNavigate() {
    this.repoService.storageNavigate(this.folderId);
  }

  openUploadWindow() {
    this.repoService.openUploadWindow(this.subFolders, this.entity);
  }

  menuClick(menuItem: Action) {
    menuItem.fn(this.folderId);
  }
}
